/**
 * `Orientation` indicates a direction of a layout that can exist in a horizontal or vertical state.
 * @public
 */
export enum Orientation {
  /**
   * `horizontal` - Layout should be horizontally oriented.
   */
  Horizontal = 'horizontal',
  /**
   * `vertical` - Layout should be horizontally oriented.
   */
  Vertical = 'vertical'
}
